/* eslint-disable */

export const listCampaigns = /* GraphQL */ `
  query ListCampaigns(
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaigns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        adminNotes
        scheduling_notes
        type
        orderlineID
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        collaborators
        mediaCollaborators
        createdAt
        updatedAt
        agency {
          id
          phone
          name
          email
          address
          postalNumber
          city
          country
          createdAt
          updatedAt
          owner
        }
        assets {
          nextToken
        }
        requiredResolutions {
          items {
            id
            campaignID
            requiredResolutionID
            createdAt
            updatedAt
            requiredResolution {
              id
              value
              type
            }
          }
        }
        nativeResolutions {
          items {
            id
            campaignID
            nativeResolutionID
            createdAt
            updatedAt
            nativeResolution {
              id
              requiredResolutionID
              value
              type
              active
              verticalCut
              horizontalCut
            }
          }
        }
        printSizes {
          items {
            id
            campaignID
            printSizeID
            createdAt
            updatedAt
            printSize {
              id
              name
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listCampaignsByCreatedAt = /* GraphQL */ `
  query ListCampaignsByCreatedAt(
    $dummyType: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignsByCreatedAt(
      dummyType: $dummyType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        adminNotes
        scheduling_notes
        type
        orderlineID
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        collaborators
        mediaCollaborators
        createdAt
        updatedAt
        requiredResolutions {
          items {
            id
            campaignID
            requiredResolutionID
            createdAt
            updatedAt
            requiredResolution {
              id
              value
              type
            }
          }
        }
      }
      nextToken
    }
  }
`;

export const listCampaignsByStatusGroup = /* GraphQL */ `
  query ListCampaignsByStatusGroup(
    $statusGroup: CAMPAIGN_STATUS_GROUP!
    $sortDirection: ModelSortDirection
    $nextToken: String
  ) {
    listCampaignsByStatusGroup(
      statusGroup: $statusGroup
      sortDirection: $sortDirection
      nextToken: $nextToken
    ) {
        items {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        type
        orderlineID
        status
        sales_segment
        requiredResolutions {
          items {
            id
            requiredResolution {
              id
              value
              type
            }
          }
        }
      }
      nextToken
    }
  }
`;

export const getCampaign = /* GraphQL */ `
  query GetCampaign($id: ID!) {
    getCampaign(id: $id) {
      id
      name
      advertiser
      contract_number
      start_time
      end_time
      deliveryDeadline
      duration
      languages
      notes
      adminNotes
      scheduling_notes
      type
      orderlineID
      sales_segment
      salesperson
      salesperson_contact
      mediaDeliveryPersonContacts
      sentTo
      status
      automaticStatus
      owner
      collaborators
      mediaAgencyID
      mediaCollaborators
      createdAt
      updatedAt
      agency {
        id
        phone
        name
        email
        address
        postalNumber
        city
        country
        createdAt
        updatedAt
        owner
      }
      assets {
        items {
          id
          name
          notes
          campaignID
          media
          thumbnail
          resolution
          metadata
          type
          fileSize
          duration
          dpi
          audio
          dynamicContent
          motiveMarker
          lowResolution
          framerate
          status
          start_time
          end_time
          week_days
          language
          language_confidence_score
          owner
          createdAt
          updatedAt
          api_files
          individualAssetIdsForMultiPagePDF
          campaign {
            id
            name
            advertiser
            orderlineID
          }
        }
        nextToken
      }
      requiredResolutions {
        items {
          id
          campaignID
          requiredResolutionID
          createdAt
          updatedAt
          requiredResolution {
            id
            value
            type
          }
        }
      }
      nativeResolutions {
        items {
          id
          campaignID
          nativeResolutionID
          createdAt
          updatedAt
          nativeResolution {
            id
            requiredResolutionID
            value
            type
            active
            verticalCut
            horizontalCut
          }
        }
      }
      printSizes {
          items {
            id
            campaignID
            printSizeID
            createdAt
            updatedAt
            printSize {
              id
              name
            }
          }
        }
    }
  }
`;

export const getCampaignContributor = /* GraphQL */ `
query GetCampaign($id: ID!) {
  getCampaign(id: $id) {
    id
    name
    advertiser
    contract_number
    start_time
    end_time
    deliveryDeadline
    duration
    languages
    notes
    type
    sentTo
    status
    automaticStatus
    owner
    collaborators
    mediaCollaborators
    createdAt
    updatedAt
    agency {
      id
      phone
      name
      email
      address
      postalNumber
      city
      country
      createdAt
      updatedAt
      owner
    }
    assets {
      items {
        id
        name
        notes
        campaignID
        media
        thumbnail
        resolution
        metadata
        type
        fileSize
        duration
        dpi
        audio
        dynamicContent
        motiveMarker
        lowResolution
        framerate
        status
        start_time
        end_time
        week_days
        language
        language_confidence_score
        owner
        createdAt
        updatedAt
        individualAssetIdsForMultiPagePDF
        campaign {
          id
          name
          advertiser
        }
      }
      nextToken
    }
    requiredResolutions {
      items {
        id
        campaignID
        requiredResolutionID
        createdAt
        updatedAt
        requiredResolution {
          id
          value
          type
        }
      }
    }
    nativeResolutions {
      items {
        id
        campaignID
        nativeResolutionID
        createdAt
        updatedAt
        nativeResolution {
          id
          requiredResolutionID
          value
          type
          active
          verticalCut
          horizontalCut
        }
      }
    }
    printSizes {
        items {
          id
          campaignID
          printSizeID
          createdAt
          updatedAt
          printSize {
            id
            name
          }
        }
      }
  }
}
`;

export const getCampaignsAssets = /* GraphQL */ `
  query GetCampaign($id: ID!, $assetsNextToken: String, $assetsLimit: Int) {
    getCampaign(id: $id) {
      id
      assets(limit: $assetsLimit, nextToken: $assetsNextToken) {
        items {
          id
          name
          notes
          campaignID
          media
          thumbnail
          resolution
          metadata
          type
          fileSize
          duration
          dpi
          audio
          dynamicContent
          motiveMarker
          lowResolution
          framerate
          status
          start_time
          end_time
          week_days
          language
          language_confidence_score
          printServiceID
          sentToPrintServiceDate
          senderToPrintService
          startprint_sender
          digitalServiceSender
          digitalServiceNames
          digitalServiceDate
          api_files
          owner
          viewers
          mediaCollaborators
          createdAt
          updatedAt
          individualAssetIdsForMultiPagePDF
          dummyType
          campaign {
            id
            name
            advertiser
            orderlineID
          }
        }
        nextToken
      }
    }
  }
`;

export const getCampaignWithAssets = /* GraphQL */ `
  query GetCampaign($id: ID!) {
    getCampaign(id: $id) {
      id
      name
      advertiser
      contract_number
      start_time
      end_time
      deliveryDeadline
      duration
      languages
      notes
      adminNotes
      scheduling_notes
      type
      orderlineID
      salesperson
      salesperson_contact
      mediaDeliveryPersonContacts
      sentTo
      status
      automaticStatus
      owner
      collaborators
      mediaCollaborators
      viewers
      createdAt
      dummyType
      updatedAt
      agency {
        id
        phone
        name
        email
        address
        postalNumber
        city
        country
        type
        contacts
        createdAt
        updatedAt
        owner
      }
      assets {
        items {
          id
          name
          notes
          campaignID
          media
          thumbnail
          resolution
          metadata
          type
          fileSize
          duration
          dpi
          audio
          dynamicContent
          motiveMarker
          lowResolution
          framerate
          status
          start_time
          end_time
          week_days
          language
          language_confidence_score
          printServiceID
          sentToPrintServiceDate
          senderToPrintService
          startprint_sender
          api_files
          owner
          viewers
          mediaCollaborators
          createdAt
          updatedAt
          individualAssetIdsForMultiPagePDF
          dummyType
          campaign {
            id
            name
            advertiser
            orderlineID
          }
        }
        nextToken
      }
      requiredResolutions {
        items {
          id
          campaignID
          requiredResolutionID
          createdAt
          updatedAt
        }
        nextToken
      }
      nativeResolutions {
        items {
          id
          campaignID
          nativeResolutionID
          createdAt
          updatedAt
        }
        nextToken
      }
      printSizes {
        items {
          id
          campaignID
          printSizeID
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;

export const listAssetsByCreatedAt = /* GraphQL */ `
  query ListAssetsByCreatedAt(
    $dummyType: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAssetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssetsByCreatedAt(
      dummyType: $dummyType
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        notes
        campaignID
        campaign {
          contract_number
          name
        }
        media
        thumbnail
        resolution
        metadata
        type
        fileSize
        duration
        dpi
        audio
        dynamicContent
        motiveMarker
        lowResolution
        framerate
        status
        start_time
        end_time
        week_days
        language
        language_confidence_score
        printServiceID
        sentToPrintServiceDate
        senderToPrintService
        startprint_sender
        digitalServiceSender
        digitalServiceDate
        digitalServiceNames
        api_files
        owner
        ownerName
        viewers
        mediaCollaborators
        createdAt
        updatedAt
        individualAssetIdsForMultiPagePDF
        dummyType
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getRequiredResolution = /* GraphQL */ `
  query GetRequiredResolution($id: ID!) {
    getRequiredResolution(id: $id) {
      id
      value
      type
      createdAt
      updatedAt
      campaigns {
        nextToken
        __typename
      }
      nativeResolutions {
        items {
          id
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;

export const listNativeResolutionsWithCampaigns = /* GraphQL */ `
  query ListNativeResolutions(
    $filter: ModelNativeResolutionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNativeResolutions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        requiredResolutionID
        value
        type
        active
        verticalCut
        horizontalCut
        createdAt
        updatedAt
        requiredResolution {
          id
          value
          type
          createdAt
          updatedAt
        }
        campaigns {
          items {
            id
            campaignID
            nativeResolutionID
            createdAt
            updatedAt
            campaign {
              id
              name
              end_time
              status
              automaticStatus
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const listPrintSizes = /* GraphQL */ `
  query ListPrintSizes(
    $filter: ModelPrintSizeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPrintSizes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
        campaigns {
          items {
            id
            campaignID
            printSizeID
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;

export const listApprovals = /* GraphQL */ `
  query ListApprovals(
    $filter: ModelApprovalFilterInput
    $nextToken: String
  ) {
    listApprovals(filter: $filter, nextToken: $nextToken) {
      nextToken
      items {
        id
        approverID
        assetID
        campaignID
        status
        reason
        createdAt
        updatedAt
        deadline
        owner
      }
    }
  }
`;

export const listApprovers = /* GraphQL */ `
  query ListApprovers {
    listApprovers {
      nextToken
      items {
        id
        userID
        name
        email
        createdAt
        updatedAt
        owner
      }
    }
  }
`;

export const listApprovalsForContributor  = /* GraphQL */ `
query ListApprovals($nextToken: String, $approverID: ID!) {
  listApprovals(filter: {approverID: {eq: $approverID}}, nextToken: $nextToken) {
    nextToken
    items {
      id
      approverID
      assetID
      campaignID
      status
      reason
      createdAt
      updatedAt
      deadline
      owner
    }
  }
}
`;

export const listCampaignsApprovals  = /* GraphQL */ `
  query ListApprovals($campaignID: ID $nextToken: String) {
    listApprovals(filter: {campaignID: {eq: $campaignID}}, nextToken: $nextToken) {
      nextToken
      items {
        id
        approverID
        assetID
        campaignID
        status
        reason
        createdAt
        updatedAt
        deadline
        owner
      }
    }
  }
`;

export const listCampaignsApprovalsForContributor = /* GraphQL */ `
query ListApprovals($campaignID: ID $approverID: ID!) {
  listApprovals(filter: {campaignID: {eq: $campaignID}, approverID: {eq: $approverID}}) {
    nextToken
    items {
      id
      approverID
      assetID
      campaignID
      status
      reason
      createdAt
      updatedAt
      deadline
      owner
    }
  }
}
`;

export const getCampaignApprovalInfo = /* GraphQL */ `
  query GetCampaign($id: ID!) {
    getCampaign(id: $id) {
      id
      name
      start_time
      end_time
      orderlineID
      status
    }
  }
`;

export const getApproverByUserId = /* GraphQL */ `
  query ListApprovers($userID: ID!) {
    listApprovers(filter: {userID: {eq: $userID}}) {
      nextToken
      items {
        id
      }
    }
  }
`

export const getUserDB = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      email
    }
  }
`;

export const listUsers = /* GraphQL */ `
  query ListUsers($nextToken: String) {
    listUsers(nextToken: $nextToken) {
      nextToken
      items {
        email
        enabled
        firstName
        id
        lastName
        userGroup
        phoneNumber
      }
    }
  }
`;

export const getApprover = /* GraphQL */ `
  query GetApprover($id: ID!) {
    getApprover(id: $id) {
      id
      name
      email
      userID
      createdAt
      updatedAt
    }
  }
`;